import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface ManuallyAttemptRekeyInput {
    orderId: string;
}

const manuallyAttemptRekey = async (data: ManuallyAttemptRekeyInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/rekey/manual`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useManuallyAttemptRekey = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (data: ManuallyAttemptRekeyInput) => manuallyAttemptRekey(data, sessionContext?.sessionId ?? null),
    });
};
